import React from "react";

const ShieldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 64 64"
      style={{ marginRight: "1vh" }}
    >
      <path
        id="Icon_awesome-shield-alt"
        data-name="Icon awesome-shield-alt"
        d="M61.192,12.24,35.592.461a6.816,6.816,0,0,0-4.92,0l-25.6,10A6,6,0,0,0,1.125,16c0,24.815,15.267,41.967,29.533,47.542a6.816,6.816,0,0,0,4.92,0C47,59.079,65.125,43.665,65.125,16,65.125,13.575,63.565,13.165,61.192,12.24ZM33.138,55.792l-.013-47.63,23.453,9.163c-.44,18.927-10.947,32.641-23.44,38.466Z"
        transform="translate(-1.125 -0.002)"
      />
    </svg>
  );
};

export default ShieldIcon;
